<template>
  <form class="form-template" :class="{'scrollable': this.formState.isComplete}" @submit.prevent="submit">
    <!-- Form Template -->
    <form-progress v-if="!this.formState.isComplete" />
    <template v-for="(field, key) in formFields">
      <field-group :field-id="key" :key="`${_uid}-${field.name}`">

        <ul :class="{'visible':(field.name !== 'info')}" class="breadcrumbs">
          <li :class="{'active':(field.name === 'symptom')}">Symtom</li>
          <li :class="{'active':(field.name === 'livsstil')}">Livsstil</li>
          <li :class="{'active':(field.name === 'sjukdomar_1' || field.name === 'sjukdomar_2' || field.name === 'sjukdomar_3')}">Sjukdom</li>
          <li :class="{'active':(field.name === 'trauma' || field.name === 'anatomi' )}">Kroppen</li>
          <li :class="{'active':(field.name === 'psykologi')}">Övrigt</li>
          <li :class="{'active':(field.name === 'lakemedel' || field.name === 'lakemedel_hjartrelaterade' || field.name === 'lakemedel_blodtrycksrelaterade' || field.name === 'lakemedel_etc' )}">Medicin</li>
        </ul>

        <div class="field-area">
          
          <h1 v-if="field.caption">{{ field.caption }}</h1>
          
          <div :class="{'switch-single-container':(field.type === 'switch'), 'switch-group-container':(field.type === 'switchgroup')}">
          
            <field-label v-if="field.question" :for="`${_uid}-${field.name}`"> {{ field.question }} </field-label>
           
            <Component
              v-model="formData[field.name]"
              :is="field.component"
              v-bind="{ ...field.options.attrs }"
              :id="`${_uid}-${field.name}`"
              :name="`${field.name}`"
              :type="field.type"
              @input="updateField({ key: field.name, value: formData[field.name] })"
              v-validate="field.validation"
              :data-vv-as="field.label"
              :options="!!field.options.choices ? field.options.choices : false"
            />
          
          </div> 
        </div>
        <field-error>{{ errors.first(field.name) }}</field-error>
      </field-group>
    </template>

    <!-- Next and Back Nav -->
    <form-nav @back="back" @next="next" @restart="restart" />

    <!-- Form Results -->
    <form-result />
  </form>
</template>

<script>
import FieldGroup from "./FormElements/FieldGroup.vue"
import FieldError from "./FormElements/FieldError.vue"
import FieldLabel from "./FormElements/FieldLabel.vue"

import FormNav from "./FormElements/FormNav.vue"
import FormResult from "./FormElements/FormResult.vue"

import FormProgress from "./FormElements/FormProgress.vue"

import formMixin from "../mixins/formMixin"
import { mapMutations } from "vuex"

export default {
  name: "form-template",
  mixins: [formMixin],
  props: ["formFields"],
  components: {
    FieldGroup,
    FieldError,
    FieldLabel,
    FormNav,
    FormResult,
    FormProgress
  },
  provide() {
    return {
      formState: this.formState
    }
  },
  methods: {
    ...mapMutations({
      updateField: "lead/updateField"
    })
  }
}
</script>
